// extracted by mini-css-extract-plugin
export default {"Container":"Page404_Container__kFt9G","content":"Page404_content__IWX9x","mainContent":"Page404_mainContent__0++bE","description":"Page404_description__sFDeG"};